<utclub-modal title="Kasa">
  <utclub-form *ngIf="formInterface" [form]="formInterface" [matDialogRef]="matDialogRef"></utclub-form>
</utclub-modal>
